import './DeviceOrientationNotification.scss';

import type { FC } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import * as state from 'state';
import * as Core from 'components/core';

import { useLocation } from 'react-router';

declare global {
  interface Window {
    DeviceOrientationEvent: {
      requestPermission?: () => Promise<PermissionState>;
    };
  }
}

interface Props {}

export const DeviceOrientationNotification: FC<Props> = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const deviceOrientationAcceptance = useReactiveVar(
    state.deviceOrientationAcceptance,
  );

  if (location.pathname !== '/' || deviceOrientationAcceptance !== 'default') {
    return null;
  }

  const onAccept = () => {
    if (
      typeof window.DeviceOrientationEvent?.requestPermission === 'function'
    ) {
      window.DeviceOrientationEvent.requestPermission().then((response) => {
        if (response === 'granted') {
          state.grantDeviceOrientation();
        } else {
          state.denyDeviceOrientation();
        }
      });
    }
  };

  return (
    <div className="DeviceOrientationNotification">
      <div className="DeviceOrientationNotification-content content-wrapper">
        <div className="DeviceOrientationNotification-explanation">
          {t('deviceOrientation.explanation')}
        </div>

        <div className="DeviceOrientationNotification-buttons">
          <Core.Button
            testID="accept-device-orientation-button"
            onClick={onAccept}
          >
            {t('deviceOrientation.accept')}
          </Core.Button>

          <Core.Button
            testID="accept-device-orientation-button"
            onClick={() => {
              state.denyDeviceOrientation();
            }}
          >
            {t('deviceOrientation.decline')}
          </Core.Button>
        </div>
      </div>
    </div>
  );
};

export default DeviceOrientationNotification;
